export async function blobToBase64(blob: Blob): Promise<string> {
    return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            const result = reader.result as string;
            resolve(result.split(',')[1]);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
}

export function countBlobParts(blobSize: number, partSize: number): number {
    return Math.ceil(blobSize / partSize);
}

export async function sliceBlobToBase64(blob: Blob, size: number): Promise<string[]> {
    const chunksCount = countBlobParts(blob.size, size);

    return Promise.all(
        Array.from({ length: chunksCount }, (_, i) => {
            const chunk = blob.slice(i * size, (i + 1) * size);
            return blobToBase64(chunk);
        }),
    );
}
